import {useReservation} from 'context/reservation';

function useRegistrationShareLink() {
  const {data} = useReservation();
  return data?.signup_form_link || '';
}

export {useRegistrationShareLink};
